<template>
  <a-input-group compact v-if="pattern=='inline'">
    <a-input v-model:value="start" style="width: 100px; text-align: center" placeholder="起始流水号" @blur="startHandle" />
    <a-input style="width: 30px; border-left: 0; pointer-events: none; backgroundcolor: #fff" placeholder="~" disabled />
    <a-input :disabled="!start" v-model:value="end" style="width: 100px; text-align: center; border-left: 0" placeholder="结束流水号" @blur="endHandle" />
  </a-input-group>
  <div v-else>
    <a-form-item label="流水号区间" :label-col="{span:6}">
      {{small_serial_start}}-{{small_serial_end}}
    </a-form-item>
    <a-form-item label="起始流水号" name='start' help="提示：仅支持最大10位纯数字流水号，而且位数必须相同" :label-col="{span:6}" :wrapper-col="{span:18}">
      <a-input v-model:value="start" style="width:200px" placeholder="起始流水号" @blur="startHandle" />
    </a-form-item>
    <a-form-item label="结束流水号" name='end' help="同一码段同一批次下的流水号范围不能重复；如果需要设定单个商品，起始和结束流水号设成一样的即可"  :label-col="{span:6}" :wrapper-col="{span:18}">
      <a-input :disabled="!start" v-model:value="end" style="width:200px" placeholder="结束流水号" @blur="endHandle" />
    </a-form-item>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { createWebHistory } from 'vue-router';
export default {
  props: {
    small_serial_start: String,
    small_serial_end: String,
    pattern: {
      type: String,
      default: () => {
        return "inline";
      },
    },
  },
  name: "batchInterval",
  setup(props, { emit }) {
    const start = ref();
    const end = ref();
    let watcher = watch(props, () => {
      if (props.small_serial_start) {
        if (!watcher) return;
        start.value = props.small_serial_start;
        end.value = props.small_serial_end;
        watcher = null;
      }
    });
    const startHandle = (e) => {
      if (isNaN(Number(e.target.value))) {
        emit("update:start", "");
        emit("update:end", "");
        start.value = "";
        end.value = "";
      }
      if (
        e.target.value.length == props.small_serial_start.length &&
        Number(props.small_serial_start) <= Number(e.target.value)
      ) {
        emit("update:start", e.target.value);
      } else {
        emit("update:start", "");
        emit("update:end", "");
        start.value = "";
        end.value = "";
      }
    };
    const endHandle = (e) => {
      console.log(e)
      if (isNaN(Number(e.target.value))) {
        emit("update:end", "");
        end.value = "";
      }
      if (
        e.target.value.length == props.small_serial_end.length &&
        Number(props.small_serial_end) >= Number(e.target.value) &&
        Number(start.value) <= Number(e.target.value)
      ) {
        console.log(e.target.value)
        emit("update:end", e.target.value);
      } else {
        emit("update:end", "");
        end.value = "";
      }
    };
    return {
      start,
      end,
      startHandle,
      endHandle,
    };
  },
};
</script>